import React from 'react';
import './index.css';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import Header from "./Components/Utils/Header";
import Footer from './Components/Utils/Footer';
import Home from './Pages/Home';
import Events from './Pages/Events';
import Team from './Pages/Team';
import PastEvents from './Pages/PastEvents';
import Discord from './Pages/Discord';
import Privacy from './Components/Utils/PrivacyPolicy';
import Terms from './Components/Utils/TermsAndConditions';
import Contact from './Components/Utils/ContactUs';
import AboutUs from './Components/Utils/AboutUs';
function App() {
  return (
    <Router>
      <div className="App">
        <Switch>
          <Route path="/event">
            <Header />
            <Events />
            <Footer />
          </Route>
          <Route path="/team">
            <Header />
            <Team />
            <Footer />
          </Route>
          <Route path="/pastEvents">
            <Header />
            <PastEvents />
            <Footer />
          </Route>
          <Route path="/discord">
            <Header />
            <Discord />
            <Footer />
          </Route>
          <Route path="/privacypolicy">
            <Header />
            <Privacy />
            <Footer />
          </Route>
          <Route path="/termsandconditions">
            <Header />
            <Terms />
            <Footer />
          </Route>
          <Route path="/aboutus">
            <Header />
            <AboutUs />
            <Footer />
          </Route>
          <Route path="/contact">
            <Header />
            <Contact />
            <Footer />
          </Route>
          <Route path="/">
            <Header />
            <Home />
            <Footer /> 
          </Route> 
        </Switch>
      </div>
    </Router>
  );
}

export default App;
